import { RegisterImages, NeonImageRegistry } from '@arcual/lib-app-neon';
import uploadImagesVideosIllustration from '@/images/imagesVideosUploadIllustration.svg';

export const initIcons = () => {
  RegisterImages.register();
  NeonImageRegistry.imageRegistry.addImage('upload-images-and-videos-illustration', uploadImagesVideosIllustration);
};
